<template>
  <th :style="styles" :class="column.head_class || ''" ref="th">
    <slot>
      {{ label }}
    </slot>
  </th>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  props: {
    column: Object,
  },
  data() {
    return {
      resizeObserve: null,
      width: this.column?.width || this.column?.minWidth || null,
    };
  },
  computed: {
    label() {
      if (typeof this.column.label !== "undefined") return this.column.label;

      const column = { ...this.column };

      return column.key.charAt(0).toUpperCase() + column.key.slice(1);
    },
    tieneWidth() {
      return !!this.column?.width;
    },
    tieneMinWidth() {
      return !!this.column?.minWidth;
    },
    styles() {
      if (this.tieneMinWidth) {
        console.log("tieneMinWidth", this.tieneMinWidth);
        return {
          width: `${this.width}px`,
        };
      }

      return {
        width: this.tieneWidth ? `${this.column.width}px` : "150px",
      };

      // if (!this.tieneWidth) {
      //   return {
      //     width: this.width < this.breakpoints.MD ? "150px" : "100%",
      //   };
      // }

      // if (!this.esAnchoDinamico) {
      //   return {
      //     width: this.column.width + "px",
      //   };
      // }

      // let width = "100%";

      // if (this.column.width?.LG && this.isLG) {
      //   width = this.column.width.LG + "px";
      // }

      // if (this.column.width?.MD && this.isMD) {
      //   width = this.column.width.MD + "px";
      // }

      // if (this.column.width?.SM && this.isSM) {
      //   width = this.column.width.SM + "px";
      // }

      // if (this.column.width?.XS && this.isXS) {
      //   width = this.column.width.XS + "px";
      // }

      // return {
      //   width: width,
      // };
    },
    esAnchoDinamico() {
      return typeof (this.column?.width || "") === "object";
    },
    ...mapState("window", ["breakpoints"]),
    ...mapGetters("window", ["isXS", "isSM", "isMD", "isLG"]),
  },
  mounted() {
    if (this.tieneMinWidth) {
      this.resizeObserve = new ResizeObserver((entries) => {
        for (let entry of entries) {
          let width = 0;

          if (entry.contentBoxSize) {
            // Firefox implements `contentBoxSize` as a single content rect, rather than an array
            const contentBoxSize = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize;

            // h1Elem.style.fontSize = Math.max(1.5, contentBoxSize.inlineSize / 200) + "rem";
            // pElem.style.fontSize = Math.max(1, contentBoxSize.inlineSize / 600) + "rem";
            width = contentBoxSize.inlineSize;
          } else {
            // h1Elem.style.fontSize = Math.max(1.5, entry.contentRect.width / 200) + "rem";
            // pElem.style.fontSize = Math.max(1, entry.contentRect.width / 600) + "rem";
            width = entry.contentRect.width;
          }

          this.handleMinWidth(width);
        }
      });

      this.resizeObserve.observe(this.$refs.th);
    }
  },
  beforeDestroy() {
    if (this.resizeObserve) {
      this.resizeObserve.unobserve(this.$refs.th);
    }
  },
  methods: {
    handleMinWidth(width) {
      console.log("Size changed", width);
      if (width < this.column.minWidth) {
        console.log("es menor");
        this.width = this.column.minWidth;
      } else {
        this.width = null;
      }
    },
  },
};
</script>
